var AfterLoginView = require('./components/Dash.vue');
var NoSideMenuView = require('./components/NoSideMenuView.vue');
var NotFoundView = require('./components/404.vue');

// var auth = require('./auth.js')
//
// function requireAuth (to, from, next) {
//	console.log(to, from)
//	auth.loggedIn(to.router.app).then(loggedIn => {
//		if (loggedIn) {
//			next()
//		} else {
//			next({
//				path: '/login',
//				query: { redirect: to.fullPath }
//			})
//		}
//	})
// }

// Routes
const routes = [
	{
		path: '/login',
		component: require('./components/Login.vue')
	},
	{
		path: '/registration',
		component: NoSideMenuView,
		// beforeEnter: requireAuth,
		children: [
			{
				path: '',
				component: require('./components/dashboard/Registration.vue'),
				name: 'title.registration'
			},
			{
				path: 'invite/:family/:token',
				component: require('./components/dashboard/Invitation.vue'),
				name: 'title.invitation'
			}
		]
	},
	{
		path: '/',
		component: AfterLoginView,
		children: [
			{
				path: '',
				component: require('./components/dashboard/Dashboard.vue'),
				name: 'title.dashboard'
			},
			{
				path: '/events',
				component: require('./components/dashboard/Events.vue'),
				name: 'title.events'
			},
			{
				path: '/family/list',
				component: require('./components/family/FamilyList.vue'),
				name: 'title.familyList'
			},
			{
				path: '/family/:id',
				component: require('./components/family/FamilyProfile.vue'),
				name: 'title.familyProfile'
			},
			{
				path: '/family/:id/edit',
				component: require('./components/family/FamilyProfileEdit.vue'),
				name: 'title.familyProfileEdit'
			},
			{
				path: '/family/:id/calendar',
				component: require('./components/family/Calendar.vue'),
				name: 'title.calendar'
			},
			{
				path: '/discussion/list',
				component: require('./components/forum/Topics.vue'),
				name: 'title.discussions'
			},
			{
				path: '/discussion/new',
				component: require('./components/forum/TopicEdit.vue'),
				name: 'title.discussionNew',
			},
			{
				path: '/discussion/:id',
				component: require('./components/forum/Topic.vue'),
				name: 'title.theme'
			},
			{
				path: '/book/list',
				component: require('./components/share/Books.vue'),
				name: 'title.books'
			},
			{
				path: '/book/new',
				component: require('./components/share/BookEdit.vue'),
				name: 'title.bookNew'
			},
			{
				path: '/book/:id',
				component: require('./components/share/BookView.vue'),
				name: 'title.bookView'
			},
			{
				path: '/book/:id/edit',
				component: require('./components/share/BookEdit.vue'),
				name: 'title.bookEdit'
			},
			{
				path: '/material/list',
				component: require('./components/share/Materials.vue'),
				name: 'title.materials'
			},
			{
				path: '/material/new',
				component: require('./components/share/LinkResourceEdit.vue'),
				name: 'title.materialNew',
				props: {resource: 'material'}
			},
			{
				path: '/material/:id',
				component: require('./components/share/MaterialView.vue'),
				name: 'title.materialView'
			},
			{
				path: '/material/:id/edit',
				component: require('./components/share/LinkResourceEdit.vue'),
				name: 'title.materialEdit',
				props: {resource: 'material'}
			},
			{
				path: '/link/list',
				component: require('./components/share/Links.vue'),
				name: 'title.links'
			},
			{
				path: '/link/new',
				component: require('./components/share/LinkResourceEdit.vue'),
				name: 'title.linkNew',
				props: {resource: 'link'}
			},
			{
				path: '/link/:id',
				component: require('./components/share/LinkView.vue'),
				name: 'title.linkView'
			},
			{
				path: '/link/:id/edit',
				component: require('./components/share/LinkResourceEdit.vue'),
				name: 'title.linkEdit',
				props: {resource: 'link'}
			},
			// Moderate
			{
				path: '/moderate/category/list',
				component: require('./components/admin/CategoryList.vue'),
				name: 'title.categoryList'
			},
			{
				path: '/moderate/category/new',
				component: require('./components/admin/CategoryEdit.vue'),
				name: 'title.categoryNew'
			},
			{
				path: '/moderate/category/:id/edit',
				component: require('./components/admin/CategoryEdit.vue'),
				name: 'title.categoryEdit'
			},
			{
				path: '/moderate/section/list',
				component: require('./components/admin/SectionList.vue'),
				name: 'title.sectionList'
			},
			{
				path: '/moderate/section/new',
				component: require('./components/admin/SectionEdit.vue'),
				name: 'title.sectionNew'
			},
			{
				path: '/moderate/section/:id/edit',
				component: require('./components/admin/SectionEdit.vue'),
				name: 'title.sectionEdit'
			},
			{
				path: '/moderate/registration/list',
				component: require('./components/admin/RegistrationList.vue'),
				name: 'title.familyRequests'
			},
			{
				path: '/moderate/registration/:id',
				component: require('./components/admin/RegistrationView.vue'),
				name: 'title.familyRequest'
			}
		]
	},
	{
		// not found handler
		path: '*',
		component: NotFoundView
	}
];

module.exports = routes;



// WEBPACK FOOTER //
// ./src/routes.js